module.exports = __webpack_public_path__ + "static/media/engineirpd4.882c82ae.svg";